import React from 'react'


function featuresbox(props) {
    return (
        <div className="a-box">
            <div className="a-b-img">
                <img src={props.image} alt="img"/>
            </div>
            <div className="a-b-text">
                <h2><span>{props.title}</span></h2>
                <p>Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.</p>
            </div>
        </div>
    )
}

export default featuresbox
